import anime from 'animejs';

let animId;
/**
 * @typedef Options
 * @property {void} onComplete
 * @property {boolean} [disabled]
 */
/**
 * @param {Event} e
 * @param {number} y
 * @param {Options} options
 */
const handler = (e, y, options) => {
    if (options?.disabled) return;

    e.preventDefault();

    if (animId) animId.remove(document.documentElement);
    animId = anime({
        targets: [document.documentElement],
        duration: 600,
        scrollTop: y,
        easing: 'easeInOutSine',
        complete: options?.onComplete,
    });
}

const cbs = new WeakMap();

/**
 * Плагин добавляет директиву v-js-anchor которую можно весить на якорные ссылки
 * для плавной прокрутки. в значение директивы можно передать ф-ю коллбек
 * которая выполнится после перемотки
 */
export default {
    install(Vue) {

        Vue.directive('js-anchor', {
            bind(el, binding, vnode) {

                const cb = (e) => {
                    const target = document.querySelector(e.currentTarget.hash);
                    const targetTop = target.getBoundingClientRect().top;

                    const offset = binding.value?.offset ?? vnode.context.$store?.getters?.['app/mainTopOffsetScrolled'] ?? 0;

                    const y = targetTop + window.scrollY - offset;

                    if (typeof binding.value === 'function') {
                        handler(e, y, { onComplete: binding.value } );
                    } else if (typeof binding.value === 'object') {
                        handler(e, y, binding.value);
                    } else {
                        handler(e, y);
                    }
                };
                cbs.set(el, cb);

                el.addEventListener('click', cb);
            },
            unbind(el) {
                el.removeEventListener('click', cbs.get(el));
            },
        });
    },
};
